<template>
  <div class="customer">
    <el-collapse v-model="selectedAccount" accordion>
      <el-collapse-item
        v-for="(supplier, index) in suppliers"
        :key="index"
        :name="supplier.id"
      >
        <template slot="title">
          <el-row>
            <el-col :span="12" class="alignItem">
              <p class="text">{{ supplier.name }}</p>
            </el-col>
            <el-col :span="12" class="d-flex">
              <el-popconfirm
                class="mr-auto"
                confirm-button-text="موافق"
                cancel-button-text="إلغاء"
                icon="el-icon-info"
                icon-color="red"
                :title="
                  'هل تريد عرض حساب المورد /  ' + ' ' + supplier.name + ' ؟'
                "
                @confirm="goTo('/suppliers/report', supplier)"
              >
                <div slot="reference">
                  <p class="text">سجل الحركات</p>
                </div>
              </el-popconfirm>
              <p class="text"></p>
              <p class="num">
                {{ numberToFixed(Number(supplier.account) + Number(supplier.balance)) }}
              </p>
              <!-- @click.stop -->
              <input
                @keyup.enter.stop
                @click.stop
                type="number"
                :class="'paied' + supplier.id"
                class="form-control paied"
                placeholder="قيمه السداد"
                @keyup.enter="pay(supplier)"
                v-model="supplier.paied"
              />
              <button
                @click="pay(supplier)"
                class="btn"
                :class="btnColor"
                @click.stop
              >
                تم
              </button></el-col
            >
          </el-row>
        </template>
        <el-row>
          <el-col :span="2">
            <el-popconfirm
              class="h mr-auto"
              confirm-button-text="موافق"
              cancel-button-text="إلغاء"
              icon="el-icon-info"
              icon-color="red"
              :title="
                'هل تريد عرض حساب المورد /  ' + ' ' + supplier.name + ' ؟'
              "
              @confirm="goTo('/suppliers/report', supplier)"
            >
              <div slot="reference">
                <button class="main-border" style="margin-top: 5px">
                  عرض <br />
                  الحساب
                </button>
              </div>
            </el-popconfirm>
          </el-col>
          <el-col :span="22">
            <el-table
              class="mt-2"
              align="right"
              v-if="report.length > 0"
              :data="report"
              border
              style="width: 100%"
            >
              <el-table-column label="#" type="index" width="50">
              </el-table-column>
              <el-table-column
                sortable
                width="100"
                label="السند"
                prop="operation_id"
              >
              </el-table-column>
              <el-table-column sortable label="التوقيت" prop="created_at">
                <template slot-scope="scope">
                  {{
                    scope.row.created_at | moment(" Do / MM / YYYY | h:mm A")
                  }}
                </template>
              </el-table-column>
              <el-table-column width="350" label="بيان" prop="description">
              </el-table-column>
              <el-table-column label="دائن">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 1">{{ scope.row.amount }}</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column label=" مدين">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 0">{{ scope.row.amount }}</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column label="بواسطة" prop="user.name"> </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import axiosApi from "@/plugins/axios.js";

export default {
  props: {
    suppliers: {
      type: Array,
    },
    btnColor: {
      type: String,
    },
  },
  data() {
    return {
      selectedAccount: "",
      report: [],
    };
  },
  watch: {
    selectedAccount: function (newValue) {
      // alert(newValue)
      this.getSupplierReportNew(newValue);
      if (this.selectedAccount != "") {
        document.querySelector(".paied" + this.selectedAccount).focus();
      } else {
        document.querySelector(".paied").focus();
      }
    },
  },

  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    pay(supplier) {
      if (supplier.paied > 0) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let paymentForm = {
          paied: supplier.paied,
          supplier: supplier,
          inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
            .id,
        };

        axiosApi
          .post("suppliers/pay", paymentForm)
          .then(() => {
            this.$notify({
              title: "تمت العملية بنجاح",
              message: "تم حفظ عملية السداد بنجاح",
              type: "success",
              duration: 1500,
            });
            setTimeout(() => {
              location.reload();
            }, 500);
          })
          .catch(() => {
            loading.close();
            this.$notify({
              title: "حدث خطأ",
              message: "عفوا لم تتم العملية ",
              type: "error",
              duration: 1500,
            });
          });
      } else {
        this.$notify({
          title: "حدث خطأ",
          message: "حدد مبلغ صحيح أولاً",
          type: "error",
          duration: 1500,
        });
      }
    },
    //
    // },
    goTo(routerName, supplier) {
      this.$router.push({
        path: routerName,
        query: { supplier_id: supplier.id },
      });
    },

    getSupplierSummary(account) {
      // customers/account-summary/{id}
      this.report = [];
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `suppliers/account-summary/${account}?limit=5`;
      axiosApi
        .get(url)
        .then((response) => {
          this.report = response.data.supplier_report;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    getSupplierReportNew(account) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `logs/suppliers/${account}?limit=10`;
      axiosApi
        .get(url)
        .then((response) => {
          this.report = response.data.supplier_report;
          const vm = this;
          let sum = 0;
          this.report.map(function (value) {
            if (value["type"] == 1) {
              sum += value["amount"];
            } else {
              sum -= value["amount"];
            }
            value["account"] = vm.numberToFixed(sum);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>
